// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAWvBo4d7g_v3AB_fqEUXGpT2Era-edQ4E",
  authDomain: "wedding-rating.firebaseapp.com",
  projectId: "wedding-rating",
  storageBucket: "wedding-rating.firebasestorage.app",
  messagingSenderId: "1095306928479",
  appId: "1:1095306928479:web:c2930f794237cde39196ea",
  measurementId: "G-CS7CMQXK5G"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);

export { db, auth, analytics };
